import { handleRequest } from "../utilities/requestHandler";

export const getAllUsers = (options = {}) => {
    const {
        page,
        limit,
        cus_id,
        site_id,
        cacheBust,
    } = options;

    const params = new URLSearchParams();
    if (page != null) params.append("page", page);
    if (limit != null) params.append("limit", limit);
    if (cus_id != null) params.append("cus_id", cus_id);
    if (site_id != null) params.append("site_id", site_id);
    if (cacheBust != null) params.append("_", cacheBust);

    const query = params.toString();
    return handleRequest("get", query ? `/users?${query}` : "/users");
};

export const getMachinesByProvision = () =>
    handleRequest("get", "/machines/by-provision");
